import * as actionTypes from './actionTypes';

export const setDirty = (isDirty) => {
  return {
    type: actionTypes.FORM_ISDIRTY,
    isDirty: isDirty
  };
};
